import React, { useEffect, useState } from "react";
import type { TableProps } from "antd";
import { Button, Table } from "antd";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import moment from "moment";
import { getCommonState, getVoucherState } from "../../redux/store/getState";
import { RequestAtc } from "../../redux/apiSlice/requestSlice";
import modifyId from "../../utils/modifyId";
import {
  filterVoucherAtc,
  getVouchersAtc,
} from "../../redux/apiActions/voucherActions";
import { useNavigate } from "react-router-dom";
import useSearch from "../../hooks/useSearch";
import { clearFilterValues } from "../../redux/apiSlice/commonSlice";

type ColumnsType<T extends object = object> = TableProps<T>["columns"];

const VoucherAtcTable: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { vouchersAtc, loading } = useAppSelector(getVoucherState);
  const { filterFrom, filterTo, atc_id } = useAppSelector(getCommonState);
  const [data, setData] = useState<RequestAtc[]>();
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });

  useSearch(vouchersAtc, setData);

  useEffect(() => {
    if (filterFrom && filterTo && atc_id) {
      dispatch(filterVoucherAtc({ from: filterFrom, to: filterTo, atc_id }));
    } else {
      dispatch(getVouchersAtc());
    }
  }, [filterFrom, filterTo, atc_id, dispatch]);

  useEffect(() => {
    //
    return () => {
      dispatch(clearFilterValues());
    };
  }, [dispatch]);

  const columns: ColumnsType<RequestAtc> = [
    {
      title: "Date and Time",
      dataIndex: "created_at",
      render: (created_at) =>
        `${moment(created_at).format("DD/MM/YYYY hh:mmA")}`,
    },
    {
      title: "Request ID",
      dataIndex: "id",
      render: (request_id) => <>{modifyId(request_id)}</>,
    },

    {
      title: "Exam ID",
      dataIndex: "exam",
      render: (exam) => <>{modifyId(exam.id)}</>,
    },
    {
      title: "Exam Name",
      dataIndex: "exam",
      render: (exam) => <>{exam.name}</>,
    },
    {
      title: "ATC Name",
      dataIndex: "atc",
      render: (atc) => <>{atc.name}</>,
    },
    {
      title: "No. of Vouchers",
      dataIndex: "number_of_vouchers",
      render: (number_of_vouchers, record) => (
        <Button
          type="link"
          onClick={() => navigate(`/voucher-management/${record.id}`)}
          style={{ color: "white" }}
        >
          {number_of_vouchers}
        </Button>
      ),
    },
  ];
  return (
    <Table
      style={{ marginTop: 20, whiteSpace: "pre" }}
      loading={loading.getRequest}
      columns={columns}
      rowKey={(record) => record.id}
      dataSource={data}
      onChange={(p) =>
        setPagination({ current: p.current || 1, pageSize: p.pageSize || 10 })
      }
      pagination={pagination}
      rowClassName={(_, index) => (index % 2 === 0 ? "tr-light" : "tr-dark")}
    />
  );
};

export default VoucherAtcTable;
